import { supabase } from '../lib/supabase';

export interface EntityContactLink {
  id: string;
  entityId: string;
  entityType: string;
  contactId: string;
  createdAt: string;
}

function mapRow(row: Record<string, unknown>): EntityContactLink {
  return {
    id: row.id as string,
    entityId: row.entity_id as string,
    entityType: row.entity_type as string,
    contactId: row.contact_id as string,
    createdAt: row.created_at as string,
  };
}

export const entityContactsService = {
  async getContactsForEntity(entityId: string): Promise<EntityContactLink[]> {
    const { data, error } = await supabase
      .from('entity_contacts')
      .select('*')
      .eq('entity_id', entityId);
    if (error) throw error;
    return (data || []).map(mapRow);
  },

  async getEntitiesForContact(contactId: string): Promise<EntityContactLink[]> {
    const { data, error } = await supabase
      .from('entity_contacts')
      .select('*')
      .eq('contact_id', contactId);
    if (error) throw error;
    return (data || []).map(mapRow);
  },

  async linkContact(
    entityId: string,
    entityType: string,
    contactId: string
  ): Promise<EntityContactLink> {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (!user) throw new Error('Non authentifié');

    const { data, error } = await supabase
      .from('entity_contacts')
      .insert({
        entity_id: entityId,
        entity_type: entityType,
        contact_id: contactId,
        user_id: user.id,
      })
      .select()
      .single();
    if (error) throw error;
    return mapRow(data);
  },

  async unlinkContact(entityId: string, contactId: string): Promise<void> {
    const { error } = await supabase
      .from('entity_contacts')
      .delete()
      .eq('entity_id', entityId)
      .eq('contact_id', contactId);
    if (error) throw error;
  },
};
